/* Evernest bag drawer behaviors: upsell one-click add + inline discount apply.
   Document-level delegation so re-rendered drawer content keeps working
   (section re-renders via innerHTML never re-execute inline scripts). */
(function () {
  if (window.__evBagBound) return;
  window.__evBagBound = true;

  var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');

  function refreshDrawer() {
    return fetch(root + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.m-cart-drawer__inner');
        var cur = document.querySelector('.m-cart-drawer__inner');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
          MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { source: 'ev-bag-drawer' });
        }
      });
  }

  /* One-click add from the "Add a little extra" cards */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ev-pair-add]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    btn.textContent = '...';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(btn.dataset.evPairAdd, 10), quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      if (window.location.pathname.indexOf('/cart') === 0) {
        window.location.reload();
        return Promise.reject('reloading');
      }
      return refreshDrawer();
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = '+ Add';
    });
  });

  /* Inline discount code apply */
  function applyDiscount(wrap) {
    var input = wrap.querySelector('[data-ev-discount-input]');
    var btn = wrap.querySelector('[data-ev-discount-apply]');
    var code = (input && input.value || '').trim();
    if (!code) return;
    btn.disabled = true;
    btn.textContent = '...';
    var before = 0;
    fetch(root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        before = cart.total_discount || 0;
        return fetch(root + 'discount/' + encodeURIComponent(code));
      })
      .then(function () { return fetch(root + 'cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var applied = (cart.total_discount || 0) > before;
        try { sessionStorage.setItem('ev-discount-msg', applied
          ? 'Discount applied.'
          : 'Code saved. If valid, it will be applied at checkout.'); } catch (err) {}
        return refreshDrawer();
      })
      .then(function () {
        var msg = document.querySelector('.ev-discount__msg');
        var text = '';
        try { text = sessionStorage.getItem('ev-discount-msg') || ''; } catch (err) {}
        if (msg && text) msg.textContent = text;
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Apply';
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ev-discount-apply]');
    if (!btn) return;
    e.preventDefault();
    applyDiscount(btn.closest('.ev-discount'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest && e.target.closest('[data-ev-discount-input]');
    if (!input) return;
    e.preventDefault();
    applyDiscount(input.closest('.ev-discount'));
  });
})();
